export default __webpack_public_path__ + "static/media/urbain1.a522bedc.jpg";